import { convertCRMDate } from "../../helper";
import { LineItems, ContractState } from "./types";

export const extractCustomerInfo = (customerSummary: string) => {
  const lines = customerSummary.split("\n");
  const customerInfo = {
    name: "",
    phone: "",
    email: "",
    address1: "",
    city: "",
    state: "",
    zip: "",
  };

  lines.forEach((line) => {
    const [key, value] = line.split(": ");
    switch (key.toLowerCase()) {
      case "name":
        customerInfo.name = value;
        break;
      case "phone":
        customerInfo.phone = value;
        break;
      case "email":
        customerInfo.email = value;
        break;
      case "address1":
        customerInfo.address1 = value;
        break;
      case "city":
        customerInfo.city = value;
        break;
      case "state":
        customerInfo.state = value;
        break;
      case "zip":
        customerInfo.zip = value;
        break;
    }
  });

  return customerInfo;
};

export const mapApiContract = (payload: any): ContractState => {
  return {
    id: payload["id"],
    name: payload["Name"],
    // calculatedRefundAmount: +payload['calculated_refund_amount'],
    regDate: convertCRMDate(payload["reg_date"]),
    deliveryDate: convertCRMDate(payload["delivery_date"]),
    expired: +payload["expired"],
    customerPhone: payload["customer_phone"],
    customerAlternatePhone: payload["customer_hphone"],
    customerEmail: payload["customer_email"],
    customerFirstName: payload["customer_fname"],
    customerLastName: payload["customer_lname"],
    customerId: payload["customer_id"] || "",
    customerAddress1: payload["customer_street1_1"],
    TCFileLink: payload["T_C_File_URL"],
    customerAddress2: payload["customer_street1_2"],
    customerCity: payload["customer_city1"],
    customerState: payload["customer_state1"],
    customerZip: payload["customer_zip1"],
    deliveryAddress1: payload["customer_street2_1"],
    deliveryAddress2: payload["customer_street2_2"],
    deliveryCity: payload["customer_city2"],
    deliveryState: payload["customer_state2"],
    deliveryZip: payload["customer_zip2"],
    invoiceNumber: payload["invoice"],
    salesPerson: payload["sales_rep"],
    storeAddress1: payload["stor_loc_address"],
    storeName: payload["stor_loc_name"],
    storeCity: payload["stor_loc_city"],
    storeState: payload["stor_loc_state"],
    totalPrice: +payload["total_price"],
    storeZip: payload["stor_loc_zip"],
    dealerSku: payload["dealer_sku"],
    warrantyProgram: payload["Warranty_Programs"]?.["name"] || "",
    warrantyProgramPrice: payload["warranty_program_price"],
    purchaseDate: convertCRMDate(payload["purchase_date"]),
    expirationDate: convertCRMDate(payload["coverage_end_date"]),
    status: payload["bp_status"],
    lineItems: payload["Line_Items"]
      ? payload["Line_Items"].map(mapApiLineItems(payload["purchase_date"]))
      : [],
    contactId: payload["Contact"]?.["id"] || "",
  };
};

const mapApiLineItems =
  (purchaseDate) =>
  (item: any = {}): LineItems => ({
    id: item["id"] || "",
    itemType: item["item_type"] || "",
    manufacturer: item["manufact"] || "",
    material: item["material"] || "",
    color: item["color"] || "",
    vendor: item["vendor"] || "",
    itemDescription: item["item_descr"] || "",
    modelNumber: item["model_num"] || "",
    deliveryDate: convertCRMDate(purchaseDate),
    retailerPrice: +item["item_price"] || 0,
    quality: item["quality"] || "",
    serialNumber: item["serial_number"] || "",
  });
